import {
  LayoutDashboard,
  CheckSquare,
  Archive,
  GitBranch,
  Network,
  Brain,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavCatalogEntry {
  key: string;                  // arbitrary unique id
  label: string;
  path: string;
  icon: LucideIcon;
  feature?: string;             // plan feature key required; omit for always-on
  permission?: string;          // RBAC permission required; omit for any tenant user
  upsellWhenLocked?: boolean;   // show as locked-with-icon vs hide entirely (default: hide)
}

export const PLATFORM_NAV_CATALOG: NavCatalogEntry[] = [
  { key: 'dashboard',     label: 'Dashboard',       path: '/',                 icon: LayoutDashboard },
  { key: 'approvals', label: 'Approvals', path: '/approvals', icon: CheckSquare },
  { key: 'records', label: 'Records', path: '/records', icon: Archive },
  { key: 'policies',      label: 'Policies',        path: '/policies',         icon: Brain },
  { key: 'approval_chains', label: 'Approval Chains', path: '/approval-chain', icon: GitBranch, feature: 'approvals', permission: 'approval_chain.write', upsellWhenLocked: true },
  { key: 'org_units',     label: 'Organization',     path: '/org-structure',    icon: Network,      feature: 'org_units',   permission: 'org_unit.read', upsellWhenLocked: true },
];
